import { Grid, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import withPrivilege from "common/hocs/withPrivilege";
import { useEffect, useState } from "react";
import { colors } from "theme/colors";
import { EntityMap } from "util/roleUtils";
import "../styles.css";
import { getDetailsById } from "components/listOfValues/utils";
import { useParams } from "react-router-dom";
import PlanDetailsPage from "./PlanDetailsPage";
import UnitPlanDetailCard from "./UnitPlanDetailCard";
import UnitPlanHeader from "./UnitPlanHeader";
import BreadCrumb from "../BreadCrumb";
import UnitPlanCard from "./UnitPlanCard";

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    flexWrap: "nowrap",
  },
  filterSection: {
    background: "white",
  },
  planSection: {
    height: "100%",
    minHeight: "100vh",
    padding: "47px 51px",
    width: "100%",
    backgroundColor: colors.gray5,
    [theme.breakpoints.down("sm")]: {
      padding: "36px",
    },
  },
  planCard: {
    marginBottom: "30px",
  },
}));

function UnitPlanDetails(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));

  const [modalState, setModalState] = useState({
    isOpen: false,
    data: null,
    isEdit: false,
  });
  const [state, setState] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    getPlanDetails();
  }, []);

  const getPlanDetails = async () => {
    const response = await getDetailsById("/unit-plan", id);
    setState(response || null);
  };

  return (
    <Grid container direction="row" className={classes.gridContainer}>
      {!isSmallDevice && (
        <Grid className={classes.filterSection} md="3" sm="12">
          <BreadCrumb
            planId={state?.tierPlanId || ""}
            planName={"UNIT_PLAN_DETAILS"}
            parentPath="unit-plans"
          />
          <UnitPlanDetailCard
            data={state}
            getPlanDetails={getPlanDetails}
            {...props}
            privileges={props?.privileges?.unitplan}
          />
        </Grid>
      )}
      <Grid className={classes.planSection} md="9" sm="12">
        {isSmallDevice && (
          <BreadCrumb
            planId={state?.tierPlanId || ""}
            planName={"UNIT_PLAN_DETAILS"}
            parentPath="unit-plans"
          />
        )}
        <UnitPlanHeader
          setModalState={setModalState}
          parentState={state}
          planId={id}
          getPlanDetails={getPlanDetails}
          {...props}
          privileges={props?.privileges?.lessonplan}
          isSmallDevice={isSmallDevice}
        />
        {isSmallDevice && (
          <Grid item className={classes.planCard} xs="12">
            <UnitPlanCard data={state} {...props} hideModification={true} isDetailedPage={true} />
          </Grid>
        )}
        <PlanDetailsPage
          {...props}
          modalState={modalState}
          setModalState={setModalState}
          parentState={state}
          getPlanDetails={getPlanDetails}
        />
      </Grid>
    </Grid>
  );
}

export default withPrivilege(
  UnitPlanDetails,
  EntityMap.unitplan,
  EntityMap.lessonplan,
  EntityMap.unitplanform
);
